// extracted by mini-css-extract-plugin
export default {"container":"hawk-promotion-pros-container","heading":"hawk-promotion-pros-heading","list":"hawk-promotion-pros-list","item":"hawk-promotion-pros-item"};